import { render, staticRenderFns } from "./OrderPay.vue?vue&type=template&id=7f8ca516&scoped=true&lang=pug&"
import script from "./OrderPay.vue?vue&type=script&lang=js&"
export * from "./OrderPay.vue?vue&type=script&lang=js&"
import style0 from "./OrderPay.vue?vue&type=style&index=0&id=7f8ca516&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ca516",
  null
  
)

export default component.exports